import { registerRoute, teacherHome } from '@lessonup/typescript-core/services';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { loggedInUser } from '../../../redux/selectors';
import { RedirectService } from '../../../services/RedirectService';

export const useRedirectForLoggedInUsers = () => {
  const user = useSelector(loggedInUser());

  useEffect(() => {
    if (!user) return;

    const path = window.location.pathname;
    const isRegistrationPage = path.includes('/register/');
    const isLoginPage = path.includes('/login/');

    if (!user.acceptedTerms && (isRegistrationPage || isLoginPage)) {
      window.open(registerRoute('terms'), '_self');
      return;
    }

    window.open(RedirectService.getRedirectUrl() || teacherHome(), '_self');
  }, [user]);
};
